import { TicketsService } from "@/services";
import dayjs from "dayjs";
import debounce from "lodash-es/debounce";
import statusChip from "@/components/TransactionsPage/StatusInTable";
import Conversation from "@/components/TicketsPage/Conversation";
import ReplyButton from "@/components/TicketsPage/ReplyButton";

export default {
  name: "single-ticket",
  components: { statusChip, Conversation, ReplyButton },
  data() {
    return {
      info: {},
      conversations: [],
      file: undefined,
      replyText: "",
      fileRules: "",
      currentPage: 1,
      totalPage: 1,
      scrollTop: 0,
      isGettingMoreConversations: false,
      closeModal: false,
      isRequesting: false
    };
  },
  computed: {
    ticketId() {
      return this.$route.params.ticketId;
    },

    isTicketClose() {
      return this.info.status && this.info.status.value === "closed";
    },

    hasMorePages() {
      return this.totalPage > this.currentPage;
    },

    scrollBtnStyle() {
      return this.scrollTop < 200 ? "opacity: 0;" : "opacity: 1;";
    },

    isFormValid() {
      return this.replyText;
    }
  },
  mounted() {
    TicketsService.getTicketInfo(this.ticketId).then(res => {
      this.info = res.data.data;
    });

    TicketsService.getConversations(this.ticketId).then(res => {
      this.conversations = res.data.data.reverse();
      this.currentPage = res.data.pagination.current_page;
      this.totalPage = res.data.pagination.total_pages;
    });
  },
  methods: {
    openTicketModal() {
      this.closeModal = true;
    },

    closeTicketModal() {
      this.closeModal = false;
    },

    openImageModal() {
      this.imageModal = true;
    },

    closeImageModal() {
      this.imageModal = false;
    },

    closeTicket() {
      TicketsService.close(this.ticketId).then(() => {
        this.closeModal = false;
        this.info.status = {
          value: "closed",
          locale: this.$t("ticketsPage.singleTicket.closed"),
          style: "default"
        };
        this.$toast.success(
          this.$t("ticketsPage.singleTicket.ticketWasClosed")
        );
        this.file = null;
      });
    },

    removeFile: debounce(function() {
      this.file = undefined;
    }, 500),

    replyTicket() {
      const data = {
        ticketId: this.ticketId,
        body: this.replyText,
        file: this.file
      };
      if (this.replyText || this.file) {
        TicketsService.reply(data)
          .then(res => {
            this.conversations.push(res.data.data);
            this.replyText = "";
            this.file = undefined;
          })
          .finally(() => (this.isRequesting = false));
        this.isRequesting = true;
      }
    },

    scrollToBottom() {
      this.$refs.conversationsRef.scrollTop = 0;
    },

    getMoreConversation() {
      this.isGettingMoreConversations = true;
      this.hasMorePages &&
        TicketsService.getConversations(this.ticketId, this.currentPage + 1)
          .then(res => {
            this.conversations = [
              ...res.data.data.reverse(),
              ...this.conversations
            ];
            this.currentPage = res.data.pagination.current_page;
            this.totalPage = res.data.pagination.total_Pages;
          })
          .finally(() => {
            this.isGettingMoreConversations = false;
          });
    },

    handleScroll({ target: { scrollTop } }) {
      this.scrollTop = scrollTop;
    }
  },
  filters: {
    fromNowDate(date) {
      return dayjs(date).format("H:m - YYYY/MM/DD");
    }
  },

  watch: {
    file: debounce(function(newFile) {
      if (newFile) {
        const isJpeg = newFile.type === "image/jpeg";
        const isPng = newFile.type === "image/png";
        const fileSize = newFile.size / 1024;
        const maxSize = 4096;
        if (!isPng && !isJpeg) {
          this.$toast.error(
            this.$t("ticketsPage.singleTicket.notAValidFormat")
          );
          this.file = null;
        } else if (fileSize > maxSize) {
          this.file = null;
          this.$toast.error(this.$t("ticketsPage.singleTicket.notAValidSize"));
        }
      }
    }, 1)
  }
};
